import type Phaser from 'phaser';
import { BootScene } from './scenes/boot/BootScene.js';
import { PreloadScene } from './scenes/boot/PreloadScene.js';
import { SplashScene } from './scenes/boot/SplashScene.js';
import { OnboardingScene } from './scenes/onboarding/index.js';
import { FortuneScene } from './scenes/onboarding/FortuneScene.js';
import { TownScene } from './scenes/town/index.js';
import { ParkScene } from './scenes/park/index.js';
import { HouseScene, HouseBuildScene } from './scenes/house/index.js';
import { WardrobeScene } from './scenes/wardrobe/index.js';
import { ShopScene } from './scenes/shop/index.js';
import { CafeScene } from './scenes/cafe/index.js';
import { SchoolScene } from './scenes/school/index.js';
import { PoolScene } from './scenes/pool/index.js';
import { StableScene } from './scenes/stable/index.js';
import { GardenScene } from './scenes/garden/index.js';
import { IcecreamScene } from './scenes/icecream/index.js';
import { VetScene } from './scenes/vet/index.js';
import { MgRhythmScene } from './minigames/rhythm/index.js';
import { MgCookingScene } from './minigames/cooking/index.js';
import { MgRunnerScene } from './minigames/runner/index.js';
import { MgBubblesScene } from './minigames/bubbles/index.js';
import { MgPuzzleScene } from './minigames/puzzle/index.js';
import { MgSwimRaceScene } from './minigames/swimrace/index.js';
import { HudScene } from './core/HudScene.js';
import { RewardScene } from './core/RewardScene.js';
import { PhoneOverlayScene } from './phone/index.js';
import { ConsoleHubScene } from './console/index.js';
import { CompanionLayerScene } from './companion/index.js';
import { QuestLayer } from './quests/index.js';

export function registerScenes(game: Phaser.Game): void {
  const scenes: Phaser.Types.Scenes.SceneType[] = [
    BootScene,
    PreloadScene,
    SplashScene,
    OnboardingScene,
    FortuneScene,
    TownScene,
    ParkScene,
    HouseScene,
    HouseBuildScene,
    WardrobeScene,
    ShopScene,
    CafeScene,
    SchoolScene,
    PoolScene,
    StableScene,
    GardenScene,
    IcecreamScene,
    VetScene,
    MgRhythmScene,
    MgCookingScene,
    MgRunnerScene,
    MgBubblesScene,
    MgPuzzleScene,
    MgSwimRaceScene,
    HudScene,
    RewardScene,
    PhoneOverlayScene,
    ConsoleHubScene,
    CompanionLayerScene,
    QuestLayer,
  ];
  for (const S of scenes) {
    game.scene.add((S as typeof BootScene).KEY ?? (S as { name: string }).name, S, false);
  }
}

export const SCENE_KEYS = {
  Boot: BootScene.KEY,
  Preload: PreloadScene.KEY,
  Splash: SplashScene.KEY,
  Onboarding: OnboardingScene.KEY,
  Fortune: FortuneScene.KEY,
  Town: TownScene.KEY,
  Park: ParkScene.KEY,
  House: HouseScene.KEY,
  HouseBuild: HouseBuildScene.KEY,
  Wardrobe: WardrobeScene.KEY,
  Shop: ShopScene.KEY,
  Cafe: CafeScene.KEY,
  School: SchoolScene.KEY,
  Pool: PoolScene.KEY,
  Stable: StableScene.KEY,
  Garden: GardenScene.KEY,
  Icecream: IcecreamScene.KEY,
  Vet: VetScene.KEY,
  MgRhythm: MgRhythmScene.KEY,
  MgCooking: MgCookingScene.KEY,
  MgRunner: MgRunnerScene.KEY,
  MgBubbles: MgBubblesScene.KEY,
  MgPuzzle: MgPuzzleScene.KEY,
  MgSwimRace: MgSwimRaceScene.KEY,
  Hud: HudScene.KEY,
  Reward: RewardScene.KEY,
  PhoneOverlay: PhoneOverlayScene.KEY,
  ConsoleHub: ConsoleHubScene.KEY,
  CompanionLayer: CompanionLayerScene.KEY,
} as const;
